import { IQueryResponse, Pagination } from '@bookips/solvook-api-shared'
import { toQueryString } from 'src/utils/misc'
import { api } from '.'

export interface UCIDTO {
	uci_code: string
	mod_date?: Date
	reg_date?: Date
	status_code?: string
	uci_format?: string
	metatype_cd?: string
	uci_mode?: string
	uci_type?: string
	user_seq?: string
	contents_con?: string
	curriculum?: string
	difficulty?: string
	edition?: string
	grade?: string
	keyword?: string
	level?: string
	memo?: string
	product_type?: string
	product_type_detail?: string
	publish_date?: string
	r_code?: string
	series?: string
	structure_type?: string
	studio_version?: string
	subject?: string
	textbook_detail?: string
	total_page?: string
	total_quiz?: string
	unit?: string
	volume?: string
	created_at?: Date
	updated_at?: Date
	title?: string
	thumb_img?: string
	product_title?: string
	thumbnail?: string
	data_type?: string
}
export interface UCIDTOs {
	uci_datas: UCIDTO[]
	pagination: Pagination
}
interface IUciRes extends IQueryResponse {
	uci: UCIDTO
}
interface IUciListRes extends IQueryResponse {
	uci_list: UCIDTOs
}
interface IFetchUCI {
	type: string
	id: string
}

interface IFetchUCIList {
	type: string // handout, quiz
	author_id?: string
	uci_code?: string
	offset?: number
	limit?: number
}
export const fetchUCI = async ({ id, type }: IFetchUCI) => {
	const { data } = await api.get<IUciRes>(`/uci${toQueryString({ id, type })}`)
	return data
}

export const fetchUCIList = async (params: IFetchUCIList) => {
	const { data } = await api.get<IUciListRes>(`/uci/list${toQueryString({ ...params })}`)
	return data
}
